// ReturnTutorialCwalk.tsx
import React from "react";
import { useTranslation } from "react-i18next";
import "../styles/RentTutorialStriemoKey.css";

const ReturnTutorialCwalk: React.FC = () => {
  const { t, i18n } = useTranslation();

  return (
    <main>
      <section className="app__return" id={`appreturn-${i18n.language}`}>
        <div className="inner-app">
          <h2 className="section-ttl">
            {t("Thank you line1")}
            <br />
            {t("Thank you line2")}
          </h2>

          <ul className="rental-warapper">
            {/* Step 1 */}
            <li className="rental-list">
              <div className="use__img-area">
                <figure className="use__img">
                  <img
                    src="/images/cwalk/parking.png"
                    alt={t("alt.parking lever")}
                  />
                </figure>
              </div>
              <div className="rental__ttl-area ">
                <h3 className="rental__ttl">
                  {t("step1.title")}
                </h3>
              </div>
              <p className="rental-discription">
                {t("step1.note")}
              </p>
            </li>

            {/* Step 2 */}
            <li className="rental-list">
              <div className="use__img-area">
                <figure className="use__img">
                  <img
                    src="/images/cwalk/btn.png"
                    alt={t("alt.power button")}
                  />
                </figure>
              </div>
              <div className="rental__ttl-area">
                <h3 className="rental__ttl">
                  {t("step2.title")}
                </h3>
              </div>
            </li>

            {/* Step 3 */}
            <li className="rental-list">
              <div className="use__img-area">
                <figure className="use__img">
                  <img
                    src="/images/cwalk/key-return.jpg"
                    alt={t("alt.key return")}
                  />
                </figure>
              </div>
              <div className="rental__ttl-area">
                <h3 className="rental__ttl">
                  {t("step3.title")}
                </h3>
              </div>
            </li>
          </ul>
        </div>
      </section>
    </main>
  );
};

export default ReturnTutorialCwalk;
